var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StringUtils } from '../../utils';
export var Legend = function (props) { return (_jsx("div", __assign({ className: StringUtils.combineStrings(['localina-legend', props.extraClassName]) }, { children: props.items.map(function (item, index) { return (_jsxs("span", __assign({ className: "localina-legend__item" }, { children: [_jsx("i", { className: "localina-legend__swatch", style: { backgroundColor: item.color }, "aria-hidden": "true" }), item.label] }), index)); }) }))); };
